/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Trans } from 'react-i18next';

type InsightClickHandler = (insightType: string, detail?: string) => void;

// Fallback genres in case there are less than 3 provided
const fallbackGenres = ['Genre 1', 'Genre 2', 'Genre 3'];

// Determine the correct translation key based on the number of genres
const getGenreKey = (count: number): string => {
  if (count <= 1) return 'SMART_INSIGHTS_GENRE_PLAYED_ONE';
  if (count === 2) return 'SMART_INSIGHTS_GENRE_PLAYED_TWO';
  return 'SMART_INSIGHTS_GENRE_PLAYED_THREE';
};

// Render the Trans component with clickable genre highlights
export const renderGenreTransContent = (
  topGenres: string[],
  onInsightClick: InsightClickHandler
): React.ReactNode => {
  const [genre1, genre2, genre3] = [...topGenres, ...fallbackGenres].slice(
    0,
    3
  );

  // Get the appropriate translation key
  const key = getGenreKey(topGenres.length);

  // Function to build clickable highlighted genre elements
  const buildHighlight = (genre?: string) => (
    <strong
      style={{
        textDecoration: 'underline',
        cursor: 'pointer',
      }}
      onClick={(event) => {
        event.stopPropagation();
        onInsightClick('genre', genre);
      }}
    />
  );

  // Prepare components for Trans
  const components = {
    ...(genre1 ? { genre1: buildHighlight(genre1) } : {}),
    ...(genre2 ? { genre2: buildHighlight(genre2) } : {}),
    ...(genre3 ? { genre3: buildHighlight(genre3) } : {}),
  };

  return (
    <Trans
      i18nKey={key}
      values={{ genre1, genre2, genre3 }}
      components={components}
    />
  );
};
